module.exports = {
        props:{
            data:Array,
            file:Object
        },
        data: function () {
            return {}
        },
        methods: {
            click:function (item) {
                if(item.disabled) return;
                if(item.callback){
                    item.callback(this.file);
                }
                this.data = null;
            }
        },
        components: {},
        ready: function () {

        }
    }


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/context-menu.vue
 ** module id = 103
 ** module chunks = 0
 **/